import { getYear } from "date-fns";
import { useEffect, useState } from "react";

import { DatetimePicker } from "@/components/ui/date-time-picker";
import { useFieldContext } from "../../../../../question/components/organisms/FieldRenderer";


export function DateRenderer() {
    const { question, setFormValue, disabled, response, currentValue } = useFieldContext();
    const [date, setDate] = useState<Date | undefined>(new Date());

    useEffect(() => {
        if(currentValue) {
            setDate(new Date(currentValue));
        }
    }, [currentValue]);

    useEffect(() => {
        if (setFormValue) {
            setFormValue(date?.toISOString() || "");
        }
    }, [date, setFormValue]);

    return (
        <div className="">
            {!disabled ? (
                ((question?.field_date_options)?.year_only === true) ? (
                    <DatetimePicker
                        value={date}
                        onChange={setDate}
                        format={{
                            dateFormat: ['years'],
                        }}
                    />
                ) : (
                    <DatetimePicker
                        value={date}
                        onChange={setDate}
                        format={{
                            dateFormat: ['years', 'months', 'days'],
                        }}
                    />
                )
            ) : (
                <div className="">
                    {(() => {
                        if (question?.field_date_options?.year_only === true) {
                            return response?.field_value?.length ? getYear(new Date(response?.field_value)) : ""
                        }
                        return response?.field_value?.length ? new Intl.DateTimeFormat('en-US').format(new Date(response?.field_value)) : ""
                    })()}
                </div>
            )}
        </div>
    )
}
